import { ASSET_MOBILE, ASSET_DESKTOP } from '../elements/assets'
import { LINK_TITLE, BUTTON_SETTINGS } from '../elements/link'

export const TEXT_AND_MEDIA = `
...on textAndMedia_Entry {
  id
  typeHandle

  backgroundColor
  position

  heading {
    html
  }
  description
  ${ LINK_TITLE }
  ${ BUTTON_SETTINGS }

  ${ ASSET_DESKTOP }
  ${ ASSET_MOBILE }

  extendWithTips

  tipHeading1
  tipIcon1 {url}
  tipDescription1
  tipHeading2
  tipIcon2 {url}
  tipDescription2
  tipHeading3
  tipIcon3 {url}
  tipDescription3
}
`